jQuery(function ($) {
	function scrollChk() {
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();

		// 視界に入ったらファイドイン
		jQuery('.js-in').not('.is-active').each(function () {
			var pos = $(this).offset().top;

			if (scroll > pos - windowHeight) {
				$(this).addClass("is-active");
			}
		});

		// 順番フェイドイン
		if (window.matchMedia("(min-width: 767px)").matches) {
			var setHeight = 200;
		} else {
			var setHeight = 100;
		}

		$('.fadeIn_list').each(function () {
			var targetPosition = $(this).offset().top;
			if (scroll > targetPosition - windowHeight + setHeight) {
				$(this).addClass('show');
			}
		})
	}
	$(window).scroll(function () {
		scrollChk();
	});
	$('body').on('touchmove', function () {
		scrollChk();
	});
});

$(window).on("load", function () {
	//ロードしてからスライド
	$('.js-load').delay(1000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more').delay(2000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});
});
